module.exports = __webpack_public_path__ + "static/media/29ADMSPC40.c6f31d52.jpg";